import { render, staticRenderFns } from "./AdminStatsCreateTask.vue?vue&type=template&id=483d77c1&scoped=true&"
import script from "./AdminStatsCreateTask.vue?vue&type=script&lang=js&"
export * from "./AdminStatsCreateTask.vue?vue&type=script&lang=js&"
import style0 from "./AdminStatsCreateTask.vue?vue&type=style&index=0&id=483d77c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483d77c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('483d77c1')) {
      api.createRecord('483d77c1', component.options)
    } else {
      api.reload('483d77c1', component.options)
    }
    module.hot.accept("./AdminStatsCreateTask.vue?vue&type=template&id=483d77c1&scoped=true&", function () {
      api.rerender('483d77c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminStatsCreateTask.vue"
export default component.exports